import React from 'react'
import { Cell } from 'rsuite-table'

type RowData = {
  [key: string]: string | boolean
}

type TemplateStatusCellProps = {
  rowData?: RowData,
  dataKey: string
}

const statusMappings: Record<string, string> = {
  Initiate: 'PENDING',
  ApprovedAdmin: 'APPROVED',
  DisApprovedAdmin: 'REJECTED',
  PendingDTL: 'PENDING',
  PendingAdmin: 'PENDING',
  DisApprovedDTL: 'REJECTED',
  ApprovedDTL: 'APPROVED'
}

const TemplateStatusCell: React.FC<TemplateStatusCellProps> = ({
  rowData,
  dataKey,
  ...props
}) => {
  const status = rowData?.[dataKey]
  const formattedStatus =
    typeof status === 'string' ? (statusMappings[status] ?? status) : 'None'

  let statusClass = ''
  if (formattedStatus === 'PENDING') {
    statusClass = 'status-pending'
  } else if (formattedStatus === 'APPROVED') {
    statusClass = 'status-approved'
  } else if (formattedStatus === 'REJECTED') {
    statusClass = 'status-rejected'
  }

  return (
    <Cell {...props}>
      {formattedStatus ? (
        <span className={`status-cell ${statusClass}`}>{formattedStatus}</span>
      ) : (
        <span className="status-blank">-</span>
      )}
    </Cell>
  )
}

export default TemplateStatusCell
